import { useState } from 'react';
import MeasurementReaderQuery from './MeasurementReaderQuery';
import MeasurementReaderResult from './MeasurementReaderResult';

function MeasurementReaderComponent(props) {
	const measurementReaderName = props.measurementReaderName || null;
	const [result, setResult] = useState(null);

	return (
		<div>
			<MeasurementReaderQuery onResult={_result => setResult(_result)} measurementReaderName={measurementReaderName} />
			{result != null && <MeasurementReaderResult result={result} onLoad={values => props.onLoad(values)} />}
		</div>
	);
}

export default MeasurementReaderComponent;